import { IN_PRODUCT } from './product'

export const NAMESPACE_URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8'

export const URL_PREFIX = '/api/v1'

export const ADMIN_URL_PREFIX = '/api/v1/admin'

export const ARTISTS_ARTWORKS_BUCKET = IN_PRODUCT ? 'revart-artist-artworks' : 'revart-artist-artworks-debug'

export const ARTISTS_COMPRESSED_ARTWORKS_BUCKET = IN_PRODUCT ? 'revart-artist-artworks-comp' : 'revart-artist-artworks-comp-debug'

export const ARTISTS_AVATAR_BUCKET = IN_PRODUCT ? 'revart-artists-profile' : 'revart-artists-profile'

export const AMAZON_S3_REGION = 'us-west-1'

export const ACCESS_KEY_ID = 'AKIAWCRNOG4OZRHOXUNO'

export const SECRET_ACCESS_KEY = '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'

export const ARTISTS_RESUME_BUCKET = IN_PRODUCT ? 'revart-artist-artworks' : 'revart-artist-artworks-debug'

export const ARTISTS_TAX_BUCKET = 'revart-artists-profile'

export const EVERSIGN_ACCESS_KEY = '6c07a391f46c4daf8efd406f8ab773f6' //Test Account: "b9e456738762c338df41336d107ec75b";

export const EVERSIGN_BUSINESS_ID = 288196 //Test Account: 322656;
